import React from 'react';
import { UploadZone } from 'src/js/component/base/upload-zone';

export const UploadZoneTest: React.FunctionComponent = () => <UploadZone />;
